import { showToast } from "common";
import Popper from "popper.js";
import React from "react";
import {MdArrowDropDown} from 'react-icons/md';

function filterDuplicateValues(map: Map<string, string>): Map<string, string> {
    const uniqueValues = new Set<string>();
    const filteredMap = new Map<string, string>();

    for (const [key, value] of map.entries()) {
        if (!uniqueValues.has(value)) {
            uniqueValues.add(value);
            filteredMap.set(key, value);
        }
    }

    return filteredMap;
}

type InputProps = {
    options: string[] | Map<string, string>;
    preventSelectOptionAndMessage?: Map<string, string>;
    selected: string;
    setSelected: (selected: string) => void;
    minWidth?: string;
    maxHeight?: string;
    textColor?: string;
    disabled?: boolean;

    hasErrorBorder?: boolean;
    placeholder?: string;
    placeholderCss?: string;
    isButton?: boolean;
    isFilterDuplicatedLabel?: boolean;
}

export function SimpleDropdown({
                                   options, selected, setSelected,
                                   minWidth = "14rem",
                                   maxHeight = "300px",
                                   textColor = "white",
                                   disabled = false,
                                   hasErrorBorder = false,
                                   placeholder = '',
                                   placeholderCss = 'text-gray-500',
                                   isButton = false,
                                   isFilterDuplicatedLabel = false,
                                   preventSelectOptionAndMessage = new Map<string, string>(),
                               }: InputProps) {
    // dropdown props
    const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
    const btnDropdownRef = React.useRef(null);
    const popoverDropdownRef = React.useRef(null);
    const nodeRef = React.useRef(null);

    const handleClickOutside = (e: Event) => {
        if ((nodeRef.current as any).contains(e.target)) {
            // outside
            return;
        }
        setDropdownPopoverShow(false);
    };
    if (!Array.isArray(options) && isFilterDuplicatedLabel) {
        options = filterDuplicateValues(options);
    }


    let keys: string[] = [];
    if (!Array.isArray(options)) {
        options.forEach((value, label) => {
            keys.push(label);
        })
    } else {
        keys = options;
    }

    const labelMap = (key: string) => {
        let label: string;
        if (!Array.isArray(options)) {
            label = options.get(key)!;
        } else {
            label = key;
        }
        return label || placeholder;
    }

    const openDropdownPopover = () => {
        new Popper(btnDropdownRef.current!, popoverDropdownRef.current!, {
            placement: "bottom-start"
        });
        setDropdownPopoverShow(true);
    };
    const closeDropdownPopover = () => {
        setDropdownPopoverShow(false);
    };

    const handleSelect = (key: string) => {
        if (preventSelectOptionAndMessage.has(key)) {
            showToast.warning(preventSelectOptionAndMessage.get(key)!, {duration: 15});
            setDropdownPopoverShow(false);
            return;
        }
        if (!Array.isArray(options)) {
            setSelected(key)
        } else {
            setSelected(key);
        }

        setDropdownPopoverShow(false);
    }

    React.useEffect(() => {
        if (dropdownPopoverShow) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownPopoverShow]);

    const bgColor = 'bg-transparent';
    return (
        <div ref={nodeRef} className="flex flex-wrap" style={{minWidth: minWidth}}>
            <div className={`flex w-full ${isButton ? 'portal-provider-fat-green-btn rounded-full' : ''}`}>
                <div
                    className={`${disabled ? "bg-gray-100 opacity-50 pointer-events-none" : "hover:border-atlantis-100"} ${hasErrorBorder ? "border-red-500" : ""} relative inline-flex align-middle w-full rounded border border-${textColor} ${isButton ? 'rounded-full' : ''}`}>
                    <button
                        className={
                            `portal-dropdown-value text-${textColor} w-full ${!selected && placeholder ? placeholderCss : 'font-bold'} text-left text-sm pl-4 pr-8 py-2 outline-none focus:outline-none ` + bgColor
                        }
                        style={{transition: "all .15s ease"}}
                        type="button"
                        ref={btnDropdownRef}
                        onClick={() => {
                            if (disabled) return;
                            dropdownPopoverShow
                                ? closeDropdownPopover()
                                : openDropdownPopover();
                        }}
                    >
                        {labelMap(selected)}
                    </button>
                    <div
                        ref={popoverDropdownRef}
                        className={
                            (dropdownPopoverShow ? "block " : "hidden ") +
                            (disabled ? "opacity-50 " : "") +
                            "bg-white text-base z-50 float-left py-2 list-none text-left shadow-lg mt-2 overflow-y-auto"
                        }
                        style={{minWidth: minWidth, maxHeight: maxHeight}}
                    >
                        {keys.map((key) => (
                            <a
                                href="#pablo"
                                key={key}
                                className={
                                    "text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap hover:bg-botticelli-100  hover:text-white " +
                                    (selected === key ? 'bg-botticelli-100 text-white' : 'bg-white text-gray-800')
                                    + (preventSelectOptionAndMessage.has(key) ? 'cursor-not-allowed text-gray-400 hover:text-red-500' : '')
                                }
                                onClick={e => {
                                    e.preventDefault();
                                    handleSelect(key)
                                }
                                }
                            >
                                {labelMap(key)}
                            </a>
                        ))}
                    </div>
                </div>

                <MdArrowDropDown className={'-ml-8 mt-1'} size={32}/>
            </div>
        </div>
    );
}
